export default "__VITE_ASSET__axpbV2vw__"